function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import RewardClaimDescription from "../RewardClaimDescription";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { isReloy } from "../../../../utils/isClient";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var FAQSection = function FAQSection(_ref) {
  var userAccountSummary = _ref.userAccountSummary,
    claimNowHandler = _ref.claimNowHandler,
    kycStatus = _ref.kycStatus,
    isPoints = _ref.isPoints,
    config = _ref.config;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var history = useHistory();
  var toggleExpand = function toggleExpand(index, question) {
    setExpanded(function (prev) {
      return prev === index ? null : index;
    });
    if (expanded !== index) {
      var _window;
      (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("FAQExpanded", {
        Number: index + 1,
        QuestionText: question
      });
    }
  };
  var referralFaqs = [{
    question: "What are these rewards for?",
    answer: "\n          These rewards are part of our exclusive loyalty program. You\u2019ve earned them through your referral activity, and you can redeem them for products that enhance your home experience.\u200B\n          "
  }, {
    question: "How do I redeem a product?",
    answer: "\n           To redeem a product, select the item(s) you like from the available options and click on \u201CRedeem.\u201D Then, follow the steps to confirm your order and the delivery will be on its way!\u200B\n          "
  }, {
    question: "How long does it take to receive my product?",
    answer: "\n            After redeeming a product, delivery usually takes 6-8 business days. We will notify you when your product is on its way!\u200B\n          "
  }, {
    question: "What happens if a product is out of stock?",
    answer: "\n           If a product is out of stock, it will be temporarily unavailable for redemption. You can check back later or choose from the other available options.\u200B\n          "
  }, {
    question: "What if my product arrives damaged?",
    answer: "\n                If your product is damaged or faulty upon arrival, please reach out to our support team at <a href=\"mailto:rewards@reloy.co\" class=\"text-blue-600 underline cursor-pointer italic\">rewards@reloy.co</a> or call us at +91-99867-34916 for assistance.\n            "
  }, {
    question: "Where can I check the status of my order?\u200B",
    answer: "Once your order is confirmed, you can check the status and track the shipment under the <a href=\"/myprofile/rewardStore/orders\" class=\"text-blue-600 italic cursor-pointer\">My Orders</a> section of your account.\u200B"
  }, {
    question: "Need help with your query?\u200B\u200B",
    answer: "Don\u2019t hesitate to reach out.\u200B\u200B"
  }, {
    question: "Contact Us\u200B\u200B\u200B",
    answer: "Tell us more about your query.\u200B\u200B\u200B"
  }];
  var reloyPointsFaqs = [{
    question: "1. What are HT Points?",
    answer: "HT Points are exclusive rewards granted for your professional contributions and network growth within the Reloy ecosystem."
  }, {
    question: "2. How can I earn HT Points?",
    answer: "You can accumulate HT points through profile completion, lead submissions and successful referral closures."
  }, {
    question: "3. Where can I use my HT Points?",
    answer: "You can use your points in the HT Points Store for various rewards across categories like electronics and lifestyle."
  }, {
    question: "4. How do I redeem my HT Points?",
    answer: "Browse the HT Points Store, select your favourite reward and complete the checkout using your available HT Points balance."
  }, {
    question: "5. What are these rewards for?",
    answer: "These rewards are part of our exclusive loyalty program, designed to thank you for your active engagement and successful referrals."
  }, {
    question: "6. Do HT Points expire?",
    answer: "HT Points may have a validity period. Please check the specific details in your account profile or the reward section for more information."
  }, {
    question: "7. Can I combine HT Points with cash?",
    answer: "No, all rewards currently require full redemption using your HT Points balance."
  }, {
    question: "8. What happens after I redeem a reward?",
    answer: "Once redeemed, you will receive a confirmation email with delivery details and an estimated timeline for your reward."
  }, {
    question: "9. Can I cancel or modify a redemption?",
    answer: "Redemptions are generally final. For any urgent assistance, contact our support team at <a href=\"mailto:rewards@reloy.co\" class=\"text-blue-600 underline cursor-pointer italic\">rewards@reloy.co</a> or call +91-99867-34916."
  }, {
    question: "10. Where can I check my HT Points balance?",
    answer: "You can view your real-time balance in your profile section or directly within the HT Points Store."
  }, {
    question: "11. How long does it take to receive my product?",
    answer: "Delivery usually takes 6\u20138 business days after redemption. We will notify you via email as soon as your product is on its way."
  }, {
    question: "12. What happens if a product is out of stock?",
    answer: "If a product is out of stock, it will be temporarily unavailable. You can choose an alternative or check back later once the HT Points Store is restocked."
  }, {
    question: "13. What if my product arrives damaged?",
    answer: "If a product arrives damaged or faulty, please reach out immediately to our support team at <a href=\"mailto:rewards@reloy.co\" class=\"text-blue-600 underline cursor-pointer italic\">rewards@reloy.co</a> or call +91-99867-34916."
  }, {
    question: "14. Where can I check the status of my order?",
    answer: "After confirmation, you can track your shipment and view current status under the <a href=\"/myprofile/coinStore/orders\" class=\"text-blue-600 italic cursor-pointer\">My Orders</a> section of your account."
  }];
  var pointsFaqs = [{
    question: "1. What are loyalty coins?",
    answer: "Loyalty coins are reward points you earn through eligible activities within the platform. These coins can be redeemed for exclusive rewards and benefits."
  }, {
    question: "2. How can I earn loyalty coins?",
    answer: "You can earn loyalty coins through eligible purchases, campaigns, referrals, or other engagement activities available on the platform."
  }, {
    question: "3. Where can I use my loyalty coins?",
    answer: "You can use your loyalty coins to redeem rewards available in the rewards store."
  }, {
    question: "4. How do I redeem my coins?",
    answer: "Browse the available rewards, select the item you want, and click on redeem to place your order using loyalty coins."
  }, {
    question: "5. What are these rewards for?",
    answer: "These rewards are specially curated products and benefits that can be redeemed using your loyalty coins."
  }, {
    question: "6. Do loyalty coins expire?",
    answer: "Loyalty coin validity may vary based on program policies. Please check your rewards section for expiry details, if applicable."
  }, {
    question: "7. Can I combine coins with cash?",
    answer: "Currently, rewards can only be redeemed using available loyalty coins unless specified otherwise for a particular reward."
  }, {
    question: "8. What happens after I redeem a reward?",
    answer: "Once redeemed, your order will be processed and delivered within the estimated timeline. You can track the status under <a href=\"/myprofile/coinStore/orders\" class=\"text-blue-600 italic cursor-pointer\">My Orders</a> section of your account."
  }, {
    question: "9. Can I cancel or modify a redemption?",
    answer: "Once a redemption request is successfully placed, it may not be modified or cancelled. Please contact support for further assistance if needed."
  }];
  var isReloyClient = isReloy(config);
  var faqs = isPoints ? isReloyClient ? reloyPointsFaqs : pointsFaqs : referralFaqs;
  var iconColor = config === null || config === void 0 ? void 0 : config.primaryColor;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col items-center justify-center",
    children: [!(config !== null && config !== void 0 && config.isCashoutDisabled) && (userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.unInvoicedCommission) > 0 && !isPoints && /*#__PURE__*/_jsxs("div", {
      className: "p-4 mt-16 rounded-2xl inline-flex flex-col lg:flex-row items-center justify-center gap-x-5 border-2 border-[#DDDDDD] mx-auto",
      children: [/*#__PURE__*/_jsx("img", {
        className: "w-full lg:w-auto",
        src: "https://cdn.loyalie.in/1724660213265_savetax"
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex items-center space-x-4 p-4 rounded-lg ",
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex-shrink-0",
          children: /*#__PURE__*/_jsx("svg", {
            xmlns: "\r\nhttp://www.w3.org/2000/svg",
            width: "50.029",
            height: "55.42",
            viewBox: "0 0 50.029 55.42",
            children: /*#__PURE__*/_jsxs("g", {
              id: "wallet",
              transform: "translate(-24.903 0)",
              children: [/*#__PURE__*/_jsxs("g", {
                id: "Group_11642",
                "data-name": "Group 11642",
                transform: "translate(25.985 1.08)",
                children: [/*#__PURE__*/_jsx("g", {
                  id: "Group_11621",
                  "data-name": "Group 11621",
                  transform: "translate(7.548)",
                  children: /*#__PURE__*/_jsx("g", {
                    id: "Group_11620",
                    "data-name": "Group 11620",
                    children: /*#__PURE__*/_jsx("g", {
                      id: "Group_11619",
                      "data-name": "Group 11619",
                      children: /*#__PURE__*/_jsx("g", {
                        id: "Group_11618",
                        "data-name": "Group 11618",
                        children: /*#__PURE__*/_jsx("path", {
                          id: "Path_7338",
                          "data-name": "Path 7338",
                          d: "M140.035,29.431a4.969,4.969,0,0,1,1.154.135l.194-.192a4.179,4.179,0,0,0,0-5.95L129.043,11.2a4.278,4.278,0,0,0-6.008,0L104.629,29.431Z",
                          transform: "translate(-104.629 -9.97)",
                          fill: "#b1d952"
                        })
                      })
                    })
                  })
                }), /*#__PURE__*/_jsx("g", {
                  id: "Group_11625",
                  "data-name": "Group 11625",
                  transform: "translate(20.34 13.207)",
                  children: /*#__PURE__*/_jsx("g", {
                    id: "Group_11624",
                    "data-name": "Group 11624",
                    children: /*#__PURE__*/_jsx("g", {
                      id: "Group_11623",
                      "data-name": "Group 11623",
                      children: /*#__PURE__*/_jsx("g", {
                        id: "Group_11622",
                        "data-name": "Group 11622",
                        children: /*#__PURE__*/_jsx("circle", {
                          id: "Ellipse_1800",
                          "data-name": "Ellipse 1800",
                          cx: "8.141",
                          cy: "8.141",
                          r: "8.141",
                          fill: "#fff"
                        })
                      })
                    })
                  })
                }), /*#__PURE__*/_jsx("g", {
                  id: "Group_11629",
                  "data-name": "Group 11629",
                  transform: "translate(0 15.139)",
                  children: /*#__PURE__*/_jsx("g", {
                    id: "Group_11628",
                    "data-name": "Group 11628",
                    children: /*#__PURE__*/_jsx("g", {
                      id: "Group_11627",
                      "data-name": "Group 11627",
                      children: /*#__PURE__*/_jsx("g", {
                        id: "Group_11626",
                        "data-name": "Group 11626",
                        children: /*#__PURE__*/_jsx("path", {
                          id: "Path_7339",
                          "data-name": "Path 7339",
                          d: "M77.857,154.142H39.4a4.5,4.5,0,0,1-4.5-4.322h0v33.62a4.522,4.522,0,0,0,4.544,4.5h38.41a4.886,4.886,0,0,0,4.91-4.862V159A4.886,4.886,0,0,0,77.857,154.142Z",
                          transform: "translate(-34.903 -149.82)",
                          fill: "#fdcb50"
                        })
                      })
                    })
                  })
                }), /*#__PURE__*/_jsx("g", {
                  id: "Group_11633",
                  "data-name": "Group 11633",
                  transform: "translate(0 15.139)",
                  children: /*#__PURE__*/_jsx("g", {
                    id: "Group_11632",
                    "data-name": "Group 11632",
                    children: /*#__PURE__*/_jsx("g", {
                      id: "Group_11631",
                      "data-name": "Group 11631",
                      children: /*#__PURE__*/_jsx("g", {
                        id: "Group_11630",
                        "data-name": "Group 11630",
                        children: /*#__PURE__*/_jsx("path", {
                          id: "Path_7340",
                          "data-name": "Path 7340",
                          d: "M41.374,162.313a29.417,29.417,0,0,1,1.15-8.171H39.4a4.5,4.5,0,0,1-4.5-4.322h0v33.62a4.522,4.522,0,0,0,4.544,4.5h16.9A29.393,29.393,0,0,1,41.374,162.313Z",
                          transform: "translate(-34.903 -149.82)",
                          fill: "#fd8f01"
                        })
                      })
                    })
                  })
                }), /*#__PURE__*/_jsx("g", {
                  id: "Group_11637",
                  "data-name": "Group 11637",
                  transform: "translate(0 10.461)",
                  children: /*#__PURE__*/_jsx("g", {
                    id: "Group_11636",
                    "data-name": "Group 11636",
                    children: /*#__PURE__*/_jsx("g", {
                      id: "Group_11635",
                      "data-name": "Group 11635",
                      children: /*#__PURE__*/_jsx("g", {
                        id: "Group_11634",
                        "data-name": "Group 11634",
                        children: /*#__PURE__*/_jsx("path", {
                          id: "Path_7341",
                          "data-name": "Path 7341",
                          d: "M39.4,106.609a4.5,4.5,0,0,0-4.5,4.5h0a4.5,4.5,0,0,0,4.5,4.5h3.048l9.087-9H39.4Z",
                          transform: "translate(-34.903 -106.609)",
                          fill: "#fff"
                        })
                      })
                    })
                  })
                }), /*#__PURE__*/_jsx("g", {
                  id: "Group_11641",
                  "data-name": "Group 11641",
                  transform: "translate(27.616 31.155)",
                  children: /*#__PURE__*/_jsx("g", {
                    id: "Group_11640",
                    "data-name": "Group 11640",
                    children: /*#__PURE__*/_jsx("g", {
                      id: "Group_11639",
                      "data-name": "Group 11639",
                      children: /*#__PURE__*/_jsx("g", {
                        id: "Group_11638",
                        "data-name": "Group 11638",
                        children: /*#__PURE__*/_jsx("path", {
                          id: "Path_7342",
                          "data-name": "Path 7342",
                          d: "M310.263,308.6H295.426a5.411,5.411,0,0,1-5.411-5.411h0a5.411,5.411,0,0,1,5.411-5.411h14.837Z",
                          transform: "translate(-290.015 -297.778)",
                          fill: "#fde0be"
                        })
                      })
                    })
                  })
                })]
              }), /*#__PURE__*/_jsx("g", {
                id: "Group_11649",
                "data-name": "Group 11649",
                transform: "translate(24.903 0)",
                children: /*#__PURE__*/_jsxs("g", {
                  id: "Group_11648",
                  "data-name": "Group 11648",
                  transform: "translate(0 0)",
                  children: [/*#__PURE__*/_jsx("g", {
                    id: "Group_11646",
                    "data-name": "Group 11646",
                    transform: "translate(27.616 31.152)",
                    children: /*#__PURE__*/_jsx("g", {
                      id: "Group_11645",
                      "data-name": "Group 11645",
                      children: /*#__PURE__*/_jsx("g", {
                        id: "Group_11644",
                        "data-name": "Group 11644",
                        children: /*#__PURE__*/_jsx("g", {
                          id: "Group_11643",
                          "data-name": "Group 11643",
                          children: /*#__PURE__*/_jsx("path", {
                            id: "Path_7343",
                            "data-name": "Path 7343",
                            d: "M300.7,300.766H286.508a6.493,6.493,0,1,1,0-12.987H300.7a1.082,1.082,0,1,1,0,2.165H286.508a4.328,4.328,0,1,0,0,8.657H300.7a1.083,1.083,0,0,1,0,2.165Z",
                            transform: "translate(-280.015 -287.779)",
                            fill: "#fd8f01"
                          })
                        })
                      })
                    })
                  }), /*#__PURE__*/_jsxs("g", {
                    id: "Group_11647",
                    "data-name": "Group 11647",
                    children: [/*#__PURE__*/_jsx("path", {
                      id: "Path_7344",
                      "data-name": "Path 7344",
                      d: "M71.866,20.217a5.265,5.265,0,0,0-.816-6.452L58.709,1.543a5.368,5.368,0,0,0-7.532,0l-9,8.915H30.486A5.589,5.589,0,0,0,24.9,16.041c0,.03,0,.06,0,.089s0,.059,0,.089v33.62a5.611,5.611,0,0,0,5.626,5.582h38.41a5.976,5.976,0,0,0,5.992-5.945V25.4A5.942,5.942,0,0,0,71.866,20.217ZM52.7,3.081a3.2,3.2,0,0,1,4.485,0L69.526,15.3a3.1,3.1,0,0,1,.191,4.205,6.065,6.065,0,0,0-.778-.05H36.165ZM30.486,12.623h9.5l-6.9,6.835h-2.6a3.406,3.406,0,0,1-3.415-3.282c0-.023,0-.045,0-.068s0-.045,0-.068A3.421,3.421,0,0,1,30.486,12.623ZM72.767,49.476a3.808,3.808,0,0,1-3.827,3.78H30.529a3.443,3.443,0,0,1-3.461-3.417V20.464a5.572,5.572,0,0,0,3.418,1.16H68.939a3.808,3.808,0,0,1,3.827,3.78V49.476Z",
                      transform: "translate(-24.903 0)",
                      fill: "#052a75"
                    }), /*#__PURE__*/_jsx("path", {
                      id: "Path_7345",
                      "data-name": "Path 7345",
                      d: "M340.7,337.764H337.38a1.083,1.083,0,0,0,0,2.165H340.7a1.083,1.083,0,0,0,0-2.165Z",
                      transform: "translate(-302.59 -301.201)",
                      fill: "#052a75"
                    })]
                  })]
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx("p", {
            className: "text-lg font-semibold",
            children: "Not tempted by our offers yet?"
          })
        })]
      }), /*#__PURE__*/_jsx("button", {
        // onClick={() => claimNowHandler(false, true, true)}
        onClick: function onClick() {
          var _window2;
          claimNowHandler(false, true, true);
          (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webengage) === null || _window2 === void 0 || _window2.track("CashOutClicked");
        },
        className: "bg-primary text-white font-semibold rounded-md  px-4 py-2",
        children: "Cash Out"
      })]
    }), !isPoints && /*#__PURE__*/_jsx("section", {
      className: "w-full mx-auto pt-16 pb-8 px-4",
      children: /*#__PURE__*/_jsx(RewardClaimDescription, {
        config: config
      })
    }), /*#__PURE__*/_jsxs("section", {
      className: "w-full mx-auto pt-12 pb-8 lg:w-[75%]",
      children: [/*#__PURE__*/_jsx("h2", {
        className: "text-center ".concat(config === null || config === void 0 ? void 0 : config.fontTitle, " ").concat(isPoints ? 'font-medium  text-2xl lg:text-3xl' : 'text-xl', " ").concat(isPoints && config !== null && config !== void 0 && config.darkMode ? 'text-white' : ''),
        children: "Frequently Asked Questions"
      }), !isPoints && /*#__PURE__*/_jsx("p", {
        className: "text-center text-gray-600 mt-2",
        children: "Quick answers to the questions you may have"
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-8 space-y-4",
        children: faqs.map(function (faq, index) {
          return /*#__PURE__*/_jsxs("div", {
            className: "rounded-lg cursor-pointer shadow-sm  ".concat(isPoints ? config !== null && config !== void 0 && config.darkMode ? 'border-2 border-primary bg-transparent p-6' : 'bg-[#f5f5f5] p-6' : 'border bg-white  p-4', " "),
            onClick: function onClick() {
              return toggleExpand(index, faq.question);
            },
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex justify-between items-center",
              children: [/*#__PURE__*/_jsx("h3", {
                className: "text-sm lg:text-lg font-medium ".concat(isPoints && config !== null && config !== void 0 && config.darkMode ? 'text-white' : ''),
                children: faq.question
              }), expanded === index ? isPoints && config !== null && config !== void 0 && config.darkMode ? /*#__PURE__*/_jsx("span", {
                className: "text-white text-2xl font-light flex-shrink-0",
                children: "\u2212"
              }) : /*#__PURE__*/_jsxs("svg", {
                id: "Group_11555",
                xmlns: "http://www.w3.org/2000/svg",
                width: "26",
                height: "26",
                viewBox: "0 0 26 26",
                className: "flex-shrink-0",
                children: [/*#__PURE__*/_jsx("rect", {
                  width: "26",
                  height: "26",
                  rx: "6",
                  fill: isPoints ? iconColor : "#4652a4"
                }), /*#__PURE__*/_jsx("rect", {
                  width: "14",
                  height: "2",
                  rx: "1",
                  transform: "translate(6 12)",
                  fill: "#fff"
                })]
              }) : isPoints && config !== null && config !== void 0 && config.darkMode ? /*#__PURE__*/_jsx("span", {
                className: "text-white text-2xl font-light flex-shrink-0",
                children: "+"
              }) : /*#__PURE__*/_jsxs("svg", {
                id: "Group_11555",
                xmlns: "http://www.w3.org/2000/svg",
                width: "26",
                height: "26",
                viewBox: "0 0 26 26",
                className: "flex-shrink-0",
                children: [/*#__PURE__*/_jsxs("g", {
                  fill: "#fff",
                  stroke: "#ddd",
                  strokeWidth: "1",
                  children: [/*#__PURE__*/_jsx("rect", {
                    width: "26",
                    height: "26",
                    rx: "6",
                    stroke: "none"
                  }), /*#__PURE__*/_jsx("rect", {
                    x: "0.5",
                    y: "0.5",
                    width: "25",
                    height: "25",
                    rx: "5.5",
                    fill: "none"
                  })]
                }), /*#__PURE__*/_jsxs("g", {
                  transform: "translate(6 5.5)",
                  children: [/*#__PURE__*/_jsx("rect", {
                    width: "14",
                    height: "2",
                    rx: "1",
                    transform: "translate(0 6)",
                    fill: isPoints ? iconColor : "#4652a4"
                  }), /*#__PURE__*/_jsx("rect", {
                    width: "14",
                    height: "2",
                    rx: "1",
                    transform: "translate(8) rotate(90)",
                    fill: isPoints ? iconColor : "#4652a4"
                  })]
                })]
              })]
            }), expanded === index && /*#__PURE__*/_jsx("div", {
              className: "mt-3 ".concat(isPoints && config !== null && config !== void 0 && config.darkMode ? 'text-gray-300' : 'text-gray-600'),
              children: /*#__PURE__*/_jsx("p", {
                dangerouslySetInnerHTML: {
                  __html: faq.answer
                }
              })
            })]
          }, index);
        })
      }), /*#__PURE__*/_jsxs("div", {
        onClick: function onClick() {
          var _window3;
          (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.webengage) === null || _window3 === void 0 || _window3.track("ContactUsClicked", {
            Section: "Rewards Store"
          });
          history.push("/contact-us");
        },
        className: "mt-12 rounded-xl p-6 flex flex-col lg:flex-row items-center justify-between cursor-pointer ".concat(isPoints && config !== null && config !== void 0 && config.darkMode ? 'border-2 border-primary bg-transparent' : 'bg-[#EDEEF0]'),
        children: [/*#__PURE__*/_jsxs("div", {
          className: "text-left mb-6 lg:mb-0",
          children: [/*#__PURE__*/_jsx("h3", {
            className: "text-lg font-bold ".concat(isPoints && config !== null && config !== void 0 && config.darkMode ? 'text-white' : ''),
            children: "Your query is still not answered?"
          }), /*#__PURE__*/_jsx("p", {
            className: "mt-2 ".concat(isPoints && config !== null && config !== void 0 && config.darkMode ? 'text-gray-300' : 'text-gray-700'),
            children: "Try contacting us"
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex items-center justify-center lg:justify-end gap-4 text-left cursor-pointer ",
          children: [/*#__PURE__*/_jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "37.323",
            height: "30.833",
            viewBox: "0 0 37.323 30.833",
            children: /*#__PURE__*/_jsx("path", {
              id: "customer-service",
              d: "M45.307,67.956a5.376,5.376,0,0,1-5.134,5.6q-.125.006-.249.006a5.272,5.272,0,0,1-1.124-.122,14.479,14.479,0,0,1-9.787,6.413,3.13,3.13,0,1,1-.1-2.273,12.194,12.194,0,1,0-12.9-6.045.74.74,0,0,1,.075.19,1.126,1.126,0,0,1-.626,1.42,5.316,5.316,0,0,1-2.063.416q-.125,0-.251-.006a5.375,5.375,0,0,1-5.131-5.6c.024-.567.011-1.073,0-1.562-.012-.461-.025-.937,0-1.434a5.38,5.38,0,0,1,5.4-5.139,14.449,14.449,0,0,1,26.5,0,5.376,5.376,0,0,1,5.4,5.138c.021.5.008.974,0,1.435C45.3,66.883,45.283,67.389,45.307,67.956ZM36.129,65.59a9.47,9.47,0,0,1-11.9,9.15L20.4,76.953a1.129,1.129,0,0,1-1.655-1.27l.979-3.653a9.467,9.467,0,1,1,16.406-6.44Zm-12.1,0A1.129,1.129,0,0,0,22.9,64.461h0a1.129,1.129,0,1,0,1.131,1.129Zm3.761,0a1.068,1.068,0,0,0-.006-.111,1.053,1.053,0,0,0-.016-.11.854.854,0,0,0-.027-.107c-.01-.035-.023-.07-.037-.1a.926.926,0,0,0-.047-.1,1.087,1.087,0,0,0-.056-.095,1.1,1.1,0,0,0-.066-.09.952.952,0,0,0-.074-.082c-.026-.026-.053-.051-.082-.075s-.059-.045-.09-.065a1.083,1.083,0,0,0-.095-.056c-.032-.017-.066-.033-.1-.047a1,1,0,0,0-.1-.037.989.989,0,0,0-.217-.044,1.157,1.157,0,0,0-.331.016,1.07,1.07,0,0,0-.108.028.991.991,0,0,0-.1.037c-.034.014-.068.03-.1.047s-.064.036-.095.056a1.1,1.1,0,0,0-.089.065c-.029.024-.056.049-.083.075a.963.963,0,0,0-.075.082,1.09,1.09,0,0,0-.065.09,1.074,1.074,0,0,0-.057.095,1.01,1.01,0,0,0-.047.1,1.106,1.106,0,0,0-.038.1c-.01.035-.019.071-.027.107a1.075,1.075,0,0,0-.017.11c0,.037-.005.074-.005.111s0,.074.005.111a1.092,1.092,0,0,0,.017.109c.008.036.017.072.027.108a1.093,1.093,0,0,0,.038.1,1.023,1.023,0,0,0,.047.1c.017.032.037.064.057.095a1.079,1.079,0,0,0,.065.089,1.107,1.107,0,0,0,.075.083c.026.026.053.051.083.075a.965.965,0,0,0,.089.065c.031.02.062.04.095.057a1.247,1.247,0,0,0,.2.084c.035.011.071.02.108.027a1.076,1.076,0,0,0,.22.022,1.135,1.135,0,0,0,.8-.33,1.221,1.221,0,0,0,.141-.172q.03-.046.056-.095c.017-.032.033-.066.047-.1a1.047,1.047,0,0,0,.037-.1.9.9,0,0,0,.027-.108,1.069,1.069,0,0,0,.016-.109,1.082,1.082,0,0,0,.006-.112Zm3.762,0a1.129,1.129,0,0,0-1.129-1.129h0a1.129,1.129,0,1,0,1.131,1.129Z",
              transform: "translate(-8.001 -51.138)",
              fill: isPoints && config !== null && config !== void 0 && config.darkMode ? "".concat(config === null || config === void 0 ? void 0 : config.primaryColor) : "#4652a4"
            })
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("h4", {
              className: "text-lg font-semibold  ".concat(isPoints && config !== null && config !== void 0 && config.darkMode ? 'text-white' : ''),
              children: "Contact Us"
            }), /*#__PURE__*/_jsx("p", {
              className: "".concat(isPoints && config !== null && config !== void 0 && config.darkMode ? 'text-gray-300' : 'text-gray-600'),
              children: "Tell us more about your query"
            })]
          }), /*#__PURE__*/_jsx("svg", {
            className: "ml-2 lg:ml-6",
            xmlns: "\r\nhttp://www.w3.org/2000/svg",
            width: "9.709",
            height: "17.068",
            viewBox: "0 0 9.709 17.068",
            children: /*#__PURE__*/_jsx("g", {
              id: "next",
              transform: "translate(0.568 0.568)",
              children: /*#__PURE__*/_jsx("g", {
                id: "Group_11658",
                "data-name": "Group 11658",
                children: /*#__PURE__*/_jsx("path", {
                  id: "Path_7346",
                  "data-name": "Path 7346",
                  d: "M126.2,7.561,118.8.181a.62.62,0,1,0-.876.878L124.885,8l-6.96,6.941a.62.62,0,0,0,.876.878l7.4-7.38a.62.62,0,0,0,0-.878Z",
                  transform: "translate(-117.742 0)",
                  fill: isPoints && config !== null && config !== void 0 && config.darkMode ? "#fff" : "#16519e",
                  stroke: isPoints && config !== null && config !== void 0 && config.darkMode ? "#fff" : "#16519e",
                  "stroke-width": "1"
                })
              })
            })
          })]
        })]
      })]
    })]
  });
};
export default FAQSection;